<div class="header fixed-top">
  <div class="top-bar">
    <p>{{ toptext }}</p>
  </div>
  <nav class="navbar navbar-expand-lg navbar-light navbar-color">
    <div class="container ">
      <img src="{{ logo }}" width="150px" class="logo-image s-img-4"/>
      <button style="position:absolute;left:15px;top:12px"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarResponsive"
        aria-controls="navbarResponsive"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" ></span>
      </button>

      <!--start ul-->
      <div id="formobdiv" >
      <ul class="navbar-nav ml-auto d-flex flex-row" id="formob">
        <a class="nav-link" href="" data-toggle="dropdown">
          <img
            class="s-left s-img-1"
            src="../../../assets/images/svg/Search.svg"
            style="width: 15px"
        /></a>
        <div class="dropdown-menu megamenu" id="search">
          <input
            id="search-1"
            type="text"
            class="form-control"
            placeholder="Search"
          />
        </div>
        <!-- <a class="nav-link" href="myaccount"><img
            class="s-left"
            src="../../../assets/images/svg/Person.svg"
            style="width: 15px"
        /></a> -->
        <li class="nav-item dropdown position-relative">
          <a
            class="nav-link hover2"
            href="myaccount"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              class="s-left s-img-2"
              src="../../../assets/images/svg/Person.svg"
              style="width: 15px"
            />
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" id="wish">
            <a class="dropdown-item" href="wishlist">Wishlist</a>
            <a class="dropdown-item" href="myaccount">Your Account</a>
          </div>
        </li>
        <a class="nav-link" href="checkout">
          <span class="badge badge-danger s-img-3">{{ cart_count }}</span>
        </a>
      </ul>
    </div>
      <!--end ul-->
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav nn" style="font-size: 14px; font-weight: 500">
          <li class="nav-item dropdown has-megamenu dropdown1">
            <a
              class="nav-link hover" data-toggle="dropdown" style="color: black" >
              Women
            </a>
            <div class="dropdown-menu megamenu dropdown-menu1">
              <div class="custom-drop-down">
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-3">
                    <p>New arrivals</p>
                    <li>New In</li>
                    <li>On Sale</li>
                    <br />
                    <p>Shop by Design</p>
                    <li>Dimdension 2044</li>
                    <li>Monogram</li>
                    <li>Love from Boo</li>
                  </div>
                  <div class="col-3">
                    <p>{{ current?.t1 }}</p>
                    <li *ngFor="let cat of current?.topwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                  </div>
                  <div class="col-5">
                    <p>{{ current?.t2 }}</p>
                    <li *ngFor="let cat of current?.bottomwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                    <br />
                    <p>Stationary</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1"></div>
                  <!--     
      <div class="col-3">Polo-t-shirts
        <li>Full sleeve t-shirt</li>
        <li>Bommer jacket</li>
        <li>Hoddles</li>
      </div> -->
                  <div class="col-5"></div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown has-megamenu dropdown2">
            <a
              class="nav-link hover1"
              (click)="setCurrent('Men')"
              data-toggle="dropdown"
              style="color: black"
            >
              Men
            </a>
            <div class="dropdown-menu megamenu dropdown-menu2">
              <div class="custom-drop-down">
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-3">
                    <p>New arrivals</p>
                    <li>New In</li>
                    <li>On Sale</li>
                    <br />
                    <p>Shop by Design</p>
                    <li>Dimdension 2044</li>
                    <li>Monogram</li>
                    <li>Love from Boo</li>
                  </div>
                  <div class="col-3">
                    <p>{{ current?.t1 }}</p>
                    <li *ngFor="let cat of current?.topwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                  </div>
                  <div class="col-5">
                    <p>{{ current?.t2 }}</p>
                    <li *ngFor="let cat of current?.bottomwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                    <br />
                    <p>Stationary</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1"></div>
                  <!--     
      <div class="col-3">Polo-t-shirts
        <li>Full sleeve t-shirt</li>
        <li>Bommer jacket</li>
        <li>Hoddles</li>
      </div> -->
                  <div class="col-5"></div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown has-megamenu dropdown3">
            <a
              class="nav-link hover"
              (click)="setCurrent('Children')"
              data-toggle="dropdown"
              style="color: black"
            >
              Children
            </a>
            <div class="dropdown-menu megamenu dropdown-menu3">
              <div class="custom-drop-down">
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-3">
                    <p>New arrivals</p>
                    <li>New In</li>
                    <li>On Sale</li>
                    <br />
                    <p>Shop by Design</p>
                    <li>Dimdension 2044</li>
                    <li>Monogram</li>
                    <li>Love from Boo</li>
                  </div>
                  <div class="col-3">
                    <p>{{ current?.t1 }}</p>
                    <li *ngFor="let cat of current?.topwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                  </div>
                  <div class="col-5">
                    <p>{{ current?.t2 }}</p>
                    <li *ngFor="let cat of current?.bottomwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                    <br />
                    <p>Stationary</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1"></div>
                  <!--     
      <div class="col-3">Polo-t-shirts
        <li>Full sleeve t-shirt</li>
        <li>Bommer jacket</li>
        <li>Hoddles</li>
      </div> -->
                  <div class="col-5"></div>
                </div>
              </div>
            </div>
          </li>
          <li class="nav-item dropdown has-megamenu">
            <a
              class="nav-link"
              (click)="setCurrent('Children')"
              data-toggle="dropdown"
              style="color: black"
            >
              Home
            </a>
            <div class="dropdown-menu megamenu">
              <div class="custom-drop-down">
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-3">
                    <p>New arrivals</p>
                    <li>New In</li>
                    <li>On Sale</li>
                    <br />
                    <p>Shop by Design</p>
                    <li>Dimdension 2044</li>
                    <li>Monogram</li>
                    <li>Love from Boo</li>
                  </div>
                  <div class="col-3">
                    <p>{{ current?.t1 }}</p>
                    <li *ngFor="let cat of current?.topwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                  </div>
                  <div class="col-5">
                    <p>{{ current?.t2 }}</p>
                    <li *ngFor="let cat of current?.bottomwear">
                      <a
                        style="color: black"
                        href="productlists/{{ cat }}/{{ cat }}"
                        >{{ cat }}</a
                      >
                    </li>
                    <br />
                    <p>Stationary</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1"></div>
                  <!--     
      <div class="col-3">Polo-t-shirts
        <li>Full sleeve t-shirt</li>
        <li>Bommer jacket</li>
        <li>Hoddles</li>
      </div> -->
                  <div class="col-5"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>

      
        <ul class="navbar-nav ml-auto d-flex flex-row" id="forweb">
           
        <li class="nav-item dropdown dropdown4">
          <a class="nav-link dropdown4" href="" data-toggle="dropdown">
            <img
              class="s-left"
              src="../../../assets/images/svg/Search.svg"
              style="width: 15px"
          /></a>
          <div class="dropdown-menu megamenu dropdown-menu4" id="search" style="padding-top:100px;text-align:center;width: 1536px;position:absolute;left:-1220px;">
            <input style="width:50%;margin-left:25%;"
              id="search-1"
              type="text"
              class="form-control"
              placeholder="Search"
            />
          </div>

        </li>
          <!-- <a class="nav-link" href="myaccount"><img
              class="s-left"
              src="../../../assets/images/svg/Person.svg"
              style="width: 15px"
          /></a> -->
          <li class="nav-item dropdown dropdown5">
            <a
              class="nav-link hover2"
              href="myaccount"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                class="s-left"
                src="../../../assets/images/svg/Person.svg"
                style="width: 15px"
              />
            </a>
            <div class="dropdown-menu dropdown-menu5" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" href="wishlist">Wishlist</a>
              <a class="dropdown-item" href="myaccount">Your Account</a>
            </div>
          </li>
          <a class="nav-link" href="checkout">
            <span class="badge badge-danger">{{ cart_count }}</span>
          </a>
        </ul>
      </div>
    </div>
  </nav>
</div>